import o from "react";
import { c as r } from "./useKeyDown-88662051.mjs";
import { u } from "./ImageContext-57256dc1.mjs";
const d = "picture", A = "picture--fall-back", C = "picture--animation", P = "skeleton-loading", E = "image__hero", R = "image__article-quote", M = "image__promotion", O = "image__card", x = "image__masonry-card", H = "image__article-page-hero", f = "image__preview_card", B = "image__map-box", b = "mobile", t = {
  picture: d,
  pictureFallBack: A,
  pictureAnimation: C,
  skeletonLoading: P,
  imageHero: E,
  imageArticleQuote: R,
  imagePromotion: M,
  imageCard: O,
  imageMasonryCard: x,
  imageArticlePageHero: H,
  imagePreviewCard: f,
  imageMapBox: B,
  mobile: b
};
var k = /* @__PURE__ */ ((e) => (e.ARTICLE_QUOTE = "imageArticleQuote", e.HERO = "imageHero", e.CARD = "imageCard", e.PROMOTION = "imagePromotion", e.MASONRY_CARD = "imageMasonryCard", e.ARTICLE_PAGE_HERO = "imageArticlePageHero", e.PREVIEW_CARD = "imagePreviewCard", e.MAPBOX = "imageMapBox", e))(k || {});
function w({
  src: e,
  width: m,
  height: c,
  altText: n,
  imageLoader: g,
  styling: a,
  className: l,
  errorHandler: s,
  credits: p
}) {
  const _ = u(), i = [n, p].filter(Boolean).join(" - ").trim();
  return /* @__PURE__ */ o.createElement(
    "picture",
    {
      className: r(t.picture),
      itemProp: "image",
      itemScope: !0,
      itemType: "https://schema.org/ImageObject"
    },
    /* @__PURE__ */ o.createElement(
      _,
      {
        src: e,
        title: i,
        width: m,
        height: c,
        alt: i,
        loading: "lazy",
        loader: g,
        className: r(l, a ? t[a] : void 0),
        onError: s,
        itemProp: "contentUrl",
        quality: 100
      }
    )
  );
}
export {
  w as I,
  k as a
};
//# sourceMappingURL=Image-be3826ec.mjs.map
